import { render, staticRenderFns } from "./ColumnMetricsTabMenu.vue?vue&type=template&id=32107738&"
import script from "./ColumnMetricsTabMenu.vue?vue&type=script&lang=ts&"
export * from "./ColumnMetricsTabMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports